const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://fp96kckqv6.execute-api.us-west-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://m5x4vyrxn8.execute-api.us-west-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'taxonomy-teams-1.15.5',
    HOSTNAME: 'https://teams-service.uat.forwood.one'
  },
  configurationService: {
    URL: 'https://config.uat.forwood.one',
    WEBSOCKET: 'wss://30xjv1z799.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;
